import React, { Component, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import DashImportacaoModel from "../../../components/classes/DashImportacao";

export default function ChartCause(props: ChartJustifyProps) {
  const [seriesMixedChart, setSeriesMixedChart] = useState<{ data: number[] }[]>([]);
  const [optionsMixedChart, setOptionsMixedChart] = useState<ApexCharts.ApexOptions>({});

  useEffect(() => {

    var groupedByJustificativa = props.data?.reduce(function (r, a) {
      r[a.justificativa] = r[a.justificativa] || [];
      r[a.justificativa].push(a);
      return r;
    }, Object.create(null)) ?? [];

    var eixoX: number[] = [];
    var eixoY: string[] = [];
    var groupedByJustificativaKeys = Object.keys(groupedByJustificativa).sort((a, b) => groupedByJustificativa[b].length - groupedByJustificativa[a].length);
    groupedByJustificativaKeys.forEach(key => {
      var x = groupedByJustificativa[key];
      eixoX.push(x.length);
      eixoY.push(!key ? 'Sem Justificativa' : key);
    });

    setSeriesMixedChart([{ data: eixoX }]);

    setOptionsMixedChart({
      chart: {
        id: "chartJustify01",
        height: 250,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          barHeight: "80%",
          borderRadius: 3,
          horizontal: true,
          dataLabels: {
            position: "bottom",
          }
        }
      },
      colors: ['#9d82f7'],
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        style: {
          colors: ['#4c4c4c']
        },
        formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex] + ":   " + val
        },
        offsetX: 0,
      },
      grid: {
        show: false,
      },
      xaxis: {
        type: "category",
        categories: eixoY
      },
      yaxis: {
        labels: {
          show: false
        }
      },
    });

  }, [props])

  return (
    <div id="chartJustify01" className="mixed-chart">
      <Chart
        options={optionsMixedChart}
        series={seriesMixedChart}
        type="bar"
        height={250}
        maxWidth={250}
      />
    </div>
  );
}

interface ChartJustifyProps {
  data?: DashImportacaoModel[]
}